import { PlaylistAdd } from "@mui/icons-material";
import { Button } from "@mui/material";
import { FC, useState } from "react";
import { useTranslation } from "react-i18next";

import { isMaxItemsReached } from "@ryde/shared";

import { PriceLevelItemEdit } from "./price-level-item.edit";
import { emptyPriceLevel, IPriceLevelItemItemForm } from "./price-level.models";

export const PriceLevelItemAdd: FC<IPriceLevelItemItemForm> = ({
  index,
  pricingType,
  fromValues,
  setValueOuter,
  fieldName,
  formAttributes,
}) => {
  const { t } = useTranslation();
  const [isAddNewOpened, setAddNewOpenedState] = useState(false);
  const hideAppendButton = isMaxItemsReached(
    formAttributes?.maxItemsToAdd,
    index || 0,
  );

  return (
    <>
      {isAddNewOpened && (
        <PriceLevelItemEdit
          fieldName={`${fieldName}[${index || 0}]`}
          setValueOuter={setValueOuter}
          value={emptyPriceLevel}
          index={index}
          pricingType={pricingType}
          fromValues={fromValues}
          formAttributes={formAttributes}
          onCancelOuter={() => {
            setAddNewOpenedState(false);
          }}
        />
      )}
      {!isAddNewOpened && !hideAppendButton && (
        <Button
          type="button"
          size="medium"
          className="add_button"
          startIcon={<PlaylistAdd />}
          onClick={() => setAddNewOpenedState(true)}
        >
          {t("general.APPEND")}
        </Button>
      )}
    </>
  );
};
